import { useEffect, useState } from 'react';

// Polls /api/videos.php every 5min. Same fallback pattern as useAnnouncement.
const POLL_MS = 5 * 60 * 1000;

export const useVideos = () => {
  const [state, setState] = useState({ videos: [], updatedAt: 0, loaded: false });

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await fetch('/api/videos.php', { cache: 'no-store' });
        if (!res.ok) throw new Error('bad status');
        const data = await res.json();
        if (!mounted) return;
        setState({
          videos: Array.isArray(data.videos) ? data.videos : [],
          updatedAt: Number(data.updatedAt || 0),
          loaded: true,
        });
      } catch {
        if (mounted) setState((s) => ({ ...s, loaded: true }));
      }
    };
    load();
    const t = setInterval(load, POLL_MS);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  return state;
};

// Convert any YouTube URL variant to a canonical embed URL.
export const toYouTubeEmbed = (url) => {
  if (!url) return '';
  try {
    const u = new URL(url);
    // youtu.be/<id>
    if (u.hostname.includes('youtu.be')) {
      const id = u.pathname.slice(1);
      return id ? `https://www.youtube.com/embed/${id}` : '';
    }
    // youtube.com/watch?v=<id>
    if (u.hostname.includes('youtube.com')) {
      if (u.pathname === '/watch') {
        const id = u.searchParams.get('v');
        return id ? `https://www.youtube.com/embed/${id}` : '';
      }
      // youtube.com/shorts/<id> or /embed/<id> or /live/<id>
      const parts = u.pathname.split('/').filter(Boolean);
      if (parts.length >= 2 && ['shorts', 'embed', 'live'].includes(parts[0])) {
        return `https://www.youtube.com/embed/${parts[1]}`;
      }
    }
    // Fallback — return as-is; iframe will do its best.
    return url;
  } catch {
    return url;
  }
};

// Extract the video ID for thumbnail generation.
export const toYouTubeThumb = (url) => {
  if (!url) return '';
  try {
    const u = new URL(url);
    let id = '';
    if (u.hostname.includes('youtu.be')) id = u.pathname.slice(1);
    else if (u.pathname === '/watch') id = u.searchParams.get('v') || '';
    else {
      const parts = u.pathname.split('/').filter(Boolean);
      if (parts.length >= 2 && ['shorts', 'embed', 'live'].includes(parts[0])) id = parts[1];
    }
    return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : '';
  } catch {
    return '';
  }
};
